import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BookmarkIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.66 4.24V20.28L12 15.36L5.34 20.28V4.24H18.66ZM12 13.1L16.82 16.78V6.08H7.18V16.78L12 13.1Z" />
    </SvgIcon>
  );
});
